import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeLineHeight = function makeLineHeight(valueReference) {
  return {
    lineHeight: "$typography.".concat(valueReference, ".lineHeight"),
    '--typography--line-height': "$typography.".concat(valueReference, ".lineHeight")
  };
};

export var typographyDefaultTheme = {
  Root: {
    base: _objectSpread(_objectSpread({
      fontSize: '$typography.body.fontSize'
    }, makeLineHeight('body')), {}, {
      fontWeight: '$typography.body.fontWeight',
      fontFamily: '$typography.body.fontFamily',
      letterSpacing: '$typography.body.letterSpacing',
      color: '$typography.body.color'
    }),
    error__disabled: {
      color: '$color.error.lighter'
    },
    error: {
      color: '$color.error.main'
    },
    disabled: {
      color: '$color.neutral.04'
    },
    pageTitle: _objectSpread(_objectSpread({
      fontSize: '$typography.pageTitle.fontSize'
    }, makeLineHeight('pageTitle')), {}, {
      letterSpacing: '$typography.pageTitle.letterSpacing'
    }),
    sectionTitle: _objectSpread({
      fontSize: '$typography.sectionTitle.fontSize'
    }, makeLineHeight('sectionTitle')),
    subSectionTitle: {
      fontWeight: '$typography.subSectionTitle.fontWeight'
    },
    label__large: {
      letterSpacing: '$typography.labelLarge.letterSpacing'
    },
    label__medium: _objectSpread(_objectSpread({}, makeLineHeight('labelMedium')), {}, {
      letterSpacing: '$typography.labelMedium.letterSpacing'
    }),
    label__small: _objectSpread(_objectSpread({
      fontSize: '$typography.labelSmall.fontSize'
    }, makeLineHeight('labelSmall')), {}, {
      letterSpacing: '$typography.labelSmall.letterSpacing'
    }),
    paragraph__large: {
      fontWeight: '$typography.paragraphLarge.fontWeight'
    },
    paragraph__medium: {
      fontSize: '$typography.paragraphMedium.fontSize',
      fontWeight: '$typography.paragraphMedium.fontWeight'
    },
    paragraph__small: _objectSpread(_objectSpread({
      fontSize: '$typography.paragraphSmall.fontSize',
      fontWeight: '$typography.paragraphSmall.fontWeight'
    }, makeLineHeight('paragraphSmall')), {}, {
      letterSpacing: '$typography.paragraphSmall.letterSpacing'
    })
  }
};